import { Pipe, PipeTransform } from '@angular/core';
import { DataUnitsTransformBigInt } from '../../lib/data-units';

@Pipe({
  name: 'dataUnitsBigInt',
  standalone: true,
})
export class DataUnitsBigIntPipe implements PipeTransform {
  transform(
    value: bigint | number | string,
    decimals = 0,
    pretty = false,
    relativeTo: bigint | number | string = 0
  ): string {
    if (!value) value = 0n;
    if (typeof value !== 'bigint') value = BigInt(value);
    if (typeof relativeTo !== 'bigint') relativeTo = BigInt(relativeTo);
    return DataUnitsTransformBigInt(value, decimals, pretty, relativeTo);
  }
}
